import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { getBatchForms } from 'actions/batches';
import { hideEditLinkedCustomerModal } from './editLinkedCustomerModal';

export const EDIT_LINKED_CUSTOMER_REQUEST = 'EDIT_LINKED_CUSTOMER_REQUEST';
export const EDIT_LINKED_CUSTOMER_SUCCESS = 'EDIT_LINKED_CUSTOMER_SUCCESS';
export const EDIT_LINKED_CUSTOMER_ERROR = 'EDIT_LINKED_CUSTOMER_ERROR';

function requestEditLinkedCustomer() {
  return {
    type: EDIT_LINKED_CUSTOMER_REQUEST,
    isRequestingEditLinkedCustomer: true,
    editLinkedCustomerResponse: null
  };
}

function receiveEditLinkedCustomer(response) {
  return {
    type: EDIT_LINKED_CUSTOMER_SUCCESS,
    isRequestingEditLinkedCustomer: false,
    editLinkedCustomerResponse: response
  };
}

function rejectEditLinkedCustomerError(error) {
  return {
    type: EDIT_LINKED_CUSTOMER_ERROR,
    isRequestingEditLinkedCustomer: false,
    editLinkedCustomerResponse: null,
    editLinkedCustomerError: error
  };
}

export function editBatchFormLinkedCustomer(formId, customerId, existingCustomerId, currentPageNumber, currentPageSize, batchId, batchFileId) {
  return (dispatch) => {
    dispatch(requestEditLinkedCustomer());

    const promise = () => ApiService
      .editFormLinkedCustomer(formId, customerId, existingCustomerId)
      .then((response) => {
        dispatch(hideEditLinkedCustomerModal());
        dispatch(receiveEditLinkedCustomer(response.data));
        toastr.success('', 'The linked customer has been updated');
        return dispatch(getBatchForms(batchId, batchFileId, currentPageNumber, currentPageSize));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response) {
          toastr.error('Edit Linked Customer Failed', error);
          dispatch(handleException(error, rejectEditLinkedCustomerError, true));
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, rejectEditLinkedCustomerError, true));
        }
      });
    return promise();
  };
}
